export default __webpack_public_path__ + "static/media/returnIcon.4178fa3e.svg";